/**
 * 
 */
import { __ } from '@wordpress/i18n';

import './variations/query/mio-exhibition-query';
import './variations/query/with-mio-exhibition-date-filter';

/**
 * Shared editor style for plugin blocks.
 * This is enqueued manually on block init.
 */
import './editor-global.scss';

// Sets custom category icon
// const mioIcon = <svg id="museio-companion__category-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 338.5 304.4">  <g> <polygon class="cls-1" points="0 189.93 0 304.4 114.47 304.4 114.47 272.5 31.9 272.5 31.9 189.93 0 189.93"/> <polygon class="cls-1" points="306.6 189.93 306.6 272.5 224.03 272.5 224.03 304.4 338.5 304.4 338.5 189.93 306.6 189.93"/> <polygon class="cls-1" points="210.08 70.19 169.2 211.96 128.56 70.19 69.97 70.19 69.97 235.59 101.86 235.59 101.86 87.21 145.1 235.59 193.54 235.59 236.54 87.21 236.54 235.59 268.44 235.59 268.44 70.19 210.08 70.19"/> <polygon class="cls-1" points="0 0 0 114.47 31.9 114.47 31.9 31.9 114.47 31.9 114.47 0 0 0"/> <polygon class="cls-1" points="224.03 0 224.03 31.9 306.6 31.9 306.6 114.47 338.5 114.47 338.5 0 224.03 0"/>  </g></svg>;
// wp.blocks.updateCategory( 'museuio-companion', { icon: mioIcon } );
// wp.blocks.updateCategory( 'museuio-companion', null );
// wp.blocks.updateCategory( 'museuio-companion', {  } );